/* tslint:disable */
/* eslint-disable */
export enum WorkMontageplanLogActionEnum {
  Swapped = 'SWAPPED',
  MovedManually = 'MOVED_MANUALLY',
  MovedAutomatically = 'MOVED_AUTOMATICALLY',
  Shortened = 'SHORTENED',
  Extended = 'EXTENDED',
  Inserted = 'INSERTED'
}
